import { GetterSetter } from "@me8eon/context";
import React, { useState } from "react";
import { JsonEditorProps } from "./editors";


export function SimpleJsonEditor({ ops, rootId }: JsonEditorProps) {
    const [showEditor, setShowEditor] = useState(false);
    const [editorValue, setEditorValue] = useState("");

    if (showEditor) {
        const invalid = () => {
            try {
                JSON.parse(editorValue);
                return false;
            } catch {
                return true;
            }
        };

        return (
            <span data-testid={rootId}>
                <button disabled={invalid()} onClick={() => {
                    ops[1](JSON.parse(editorValue));
                    setShowEditor(false);
                }}>Save</button><br />
                <textarea
                    data-testid={rootId + ".textarea"}
                    value={editorValue}
                    rows={10}
                    cols={80}
                    onChange={e => setEditorValue(e.target.value)}
                />
            </span>
        );
    }

    return (
        <div data-testid={rootId}>
            <button onClick={() => {
                setEditorValue(JSON.stringify(ops[0], null, 2));
                setShowEditor(true);
            }}>Edit
            </button>
            <br />
            <pre data-testid={rootId + ".json"}>{JSON.stringify(ops[0], null, 2)}</pre>
        </div>
    );
}